export default __webpack_public_path__ + "static/media/Mark-5-Suit-11.5f34dfed.jpg";